import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { authenticatedBackendFetch } from "./ApiService";
import { TimePeriod } from "../types/TimePeriod";
import { FinanceOverviewItem } from "../types/FinanceOverviewItem";

const mailServiceUrl = process.env.REACT_APP_FINANCE_MAILSERVICE_URL;

export async function ToggleUserNotificationsAsync(
  instance: IPublicClientApplication,
  account: AccountInfo,
  userId: number,
) {
  const response = await authenticatedBackendFetch(
    `users/${userId}/toggle-notifications`,
    instance,
    account,
    {
      method: "POST",
    },
  );

  if (!response.ok) {
    throw new Error("Failed to toggle user notifications");
  }
}

export async function SendReminderToProjectManagersAsync() {
  const response = await fetch(`${mailServiceUrl}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    console.error(response);
    throw new Error("BadRequest");
  }
}

export async function GetFinanceOverviewDataAsync(
  instance: IPublicClientApplication,
  account: AccountInfo,
  timePeriod: TimePeriod,
) {
  const response = await authenticatedBackendFetch(
    `projects/overview?month=${timePeriod.Month}&year=${timePeriod.Year}`,
    instance,
    account,
  );

  if (!response.ok) {
    console.error(response);
    return;
  }

  const data: FinanceOverviewItem[] = await response.json();

  return data;
}
